import { ApolloClient, ApolloLink, ApolloProvider, createHttpLink } from '@apollo/client';
import {
  InMemoryCache
} from '@apollo/client/cache';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
// import { getToken } from './AuthProvider';
import { WebSocketLink } from '@apollo/client/link/ws';
import jwtDecode from 'jwt-decode';
import _ from 'lodash';
import moment from 'moment';
import React, { useLayoutEffect, useRef, useState } from 'react';
import Config from '../config';

const errorHandler = (error) => {
  const { graphQLErrors, networkError, operation } = error;

  if (graphQLErrors) {
    graphQLErrors.forEach(({ extensions: { code, path }, message, locations }) => {
      const graphQLErrorMsg = `[GraphQL error]: Operation: ${operation.operationName}, Message: ${message}, Location: ${locations}, Path: ${path}`
      console.log(graphQLErrorMsg);
      // invariant.warn(graphQLErrorMsg);
      // captureException(new Error(graphQLErrorMsg), { code, path, message, locations });
    });
  }

  if (_.isObject(networkError)) {
    console.log(`[Network error]: Operation: ${operation.operationName}, Error: ${networkError}`);
    // invariant.warn(false, `[Network error]: Operation: ${operation.operationName}, Error: ${networkError}`);

    // captureException(networkError);
  }
};

// function getToken() {
//   return localStorage.getItem('token') || sessionStorage.getItem('token');
// }

// function setToken(value) {
//   if (localStorage.getItem('token')) {
//     localStorage.setItem('token', value);
//   } else {
//     sessionStorage.setItem('token', value);
//   }
//   return value;
// }

let wsHasuraLink;

const createLink = (setLastUpdateFn, firebaseAuth) => {

  const authMiddleware = setContext(() => {
    const headers = {};
    // console.log('Enter authMiddleware Promise');
    headers["JWT_AUD"] = "https://identitytoolkit.googleapis.com/google.identity.identitytoolkit.v1.IdentityToolkit"
    if (firebaseAuth.currentUser) {
      return firebaseAuth.currentUser.getIdToken().then(token => {
        if (token) headers['Authorization'] = `Bearer ${token}`;
        return { headers: headers };
      });
    } else {
      return { headers: headers };
    }
  });

  const lastUpdateMiddleware = new ApolloLink((operation, forward) => {
    return forward(operation).map(response => {
      // console.log('Enter lastUpdateMiddleware');
      const { data } = response;
      if (data) {
        const register = data[Object.keys(data)[0]];
        if (hasAnyMutation(operation)) {
          setLastUpdateFn(register.updatedAt ?? moment().format("YYYY-MM-DDTHH:mm:ss.SSS"));
          // window['lastUpdate'] = register.updatedAt ?? moment().format("YYYY-MM-DDTHH:mm:ss.SSS");
        }

        const context = operation.getContext();
        const { response: { headers } } = context;
        if (headers && headers.get("Authorization")) {
          const token = headers.get("Authorization").split(' ')[1];

          if (token) {
            // login({ token: token })
            if (response['data']) {
              response['data']['token'] = token;
            }
            // setToken(token);
          }
        }
      }
      return response;
    });
  });

  const railsLoginLink = createHttpLink({
    uri: Config.GRAPHQL_ENDPOINT,
    credentials: 'same-origin',
  });

  const httpHasuraLink = createHttpLink({
    uri: Config.GRAPHQL_HASURA_ENDPOINT,
    credentials: 'same-origin',
  });

  wsHasuraLink = new WebSocketLink({
    uri: Config.WEBSOCKET_HASURA_ENDPOINT,
    options: {
      lazy: true,
      reconnect: true,
      connectionParams: () => new Promise((resolve, reject) => {
        // console.log('Enter ConnectionParams Promise');
        const headers = {
          "JWT_AUD": "https://identitytoolkit.googleapis.com/google.identity.identitytoolkit.v1.IdentityToolkit"
        }
        if (firebaseAuth.currentUser) {
          firebaseAuth.currentUser.getIdToken().then(token => {
            const decodedToken = jwtDecode(token);
            console.log(decodedToken, "FIREBASE");
            if (token) headers['Authorization'] = `Bearer ${token}`;
            resolve({ headers: headers });
          })
        } else {
          resolve({ headers: headers });
        }
      })
    }
  });

  const hasSubscriptionOperation = ({ query: { definitions } }) => {
    return definitions.some(
      ({ kind, operation, name }) => (kind === 'OperationDefinition' && operation === 'subscription') || (kind === 'OperationDefinition' && operation === 'mutation' && name && name.value === 'UpdateUploadState')
    )
  }

  const hasLoginMutation = ({ query: { definitions } }) => {
    return definitions.some(
      ({ kind, operation, name }) => kind === 'OperationDefinition' && (
        // (operation === 'query' && name && ['FindWithInvitationToken', 'UnlockUser'].includes(name.value)) ||
        (operation === 'mutation' && name && ['BackofficeLogin'].includes(name.value))
      )
    )
  }

  const hasAnyMutation = ({ query: { definitions } }) => {
    return definitions.some(
      ({ kind, operation, name }) => kind === 'OperationDefinition' && operation === 'mutation'
    )
  }

  const hasuraLink = ApolloLink.split(
    // if has subscription operation
    hasSubscriptionOperation,
    // use wsHasuraLink
    wsHasuraLink,
    // or use authMiddleware and lastUpdateMiddleware with hasura link
    ApolloLink.from([authMiddleware, lastUpdateMiddleware, httpHasuraLink])
  );

  // This is the final GraphQL Link
  const appLink = ApolloLink.split(
    // if has login mutation
    hasLoginMutation,
    // use authMiddleware and lastUpdateMiddleware with rails login link
    ApolloLink.from([authMiddleware, lastUpdateMiddleware, railsLoginLink]),
    // or use hasura link
    hasuraLink
  );

  return ApolloLink.from([onError(errorHandler), appLink]);
};

const createCache = () => new InMemoryCache({
  typePolicies: {
    processings_projects: {
      keyFields: ["projectId", "processingId"],
    },
    processingsProjects: {
      keyFields: ["projectId", "processingId"],
    },
    processingsProjects_aggregate: {
      keyFields: []
    },
    processings_projects_aggregate: {
      keyFields: []
    },
    projectImageFiles: {
      keyFields: ["id"]
    },
    project_image_files: {
      keyFields: ["id"]
    },
    annotationFolderPermissions: {
      keyFields: ["id"]
    },
    annotation_folder_permissions: {
      keyFields: ["id"]
    },
    annotationPermissions: {
      keyFields: ["id"]
    },
    annotation_permissions: {
      keyFields: ["id"]
    },
    spatial_ref_sys: {
      keyFields: ["srid"],
    },
    epsg_epsg_coordinatereferencesystem: {
      keyFields: ["coord_ref_sys_code"],
    }
  },
  // dataIdFromObject: object => {
  //   switch (object.__typename) {
  //     case 'processings_projects': return `processings_projects:${(object as any).projectId}_${(object as any).processingId}`; // use the `key` field as the identifier
  //     case 'spatial_ref_sys': return `spatial_ref_sys:${(object as any).srid}`;
  //     case 'epsg_epsg_coordinatereferencesystem': return `epsg_epsg_coordinatereferencesystem:${(object as any).coord_ref_sys_code}`;
  //     default: return defaultDataIdFromObject(object); // fall back to default handling
  //   }
  // }
});

export function createClient(setLastUpdateFn, firebaseAuth) {
  return new ApolloClient({
    cache: createCache(),
    link: createLink(setLastUpdateFn, firebaseAuth),
    connectToDevTools: true,
  });
}

export function renderErrors(errors, customDict) {
  return errors.map(error => {
    let { message, code, field } = error;

    if (customDict[message]) {
      message = customDict[message];
    } else {
      switch (message) {
        case 'email or password is invalid':
          field = 'email';
          message = 'Email ou senha inválidos.';
          break;
        case 'Network error: Failed to fetch':
          message = 'Falha na conexão. Tente novamente mais tarde.';
          break;
        default:
          console.log(message);
          message = "Erro desconhecido, veja o console."
      }
    }

    return {
      code,
      field,
      ...(_.isString(message) ? { message } : message),
    };
  });
}

// TODO: add support to payload errors
export function mutationErrors(name, result, customDict = {}) {
  if (result.called && !result.loading) {
    const { error, data } = result;
    // Network error
    if (error) {
      return renderErrors([error], customDict);
    } else if (!_.get(data, [name, 'successful'])) {
      return renderErrors(_.get(data, [name, 'messages'], []), customDict);
    }
  }

  return [];
}

// let client;

export const GraphqlProvider = ({ children, firebaseApp }) => {
  const auth = useRef(firebaseApp.auth());
  const [lastUpdate, setLastUpdate] = useState(moment().format("YYYY-MM-DDTHH:mm:ss.SSS"));
  const [client, setClient] = useState();

  useLayoutEffect(() => {
    setClient(createClient(setLastUpdate, auth.current));
  }, []);

  // Remove all data from the store. Unlike resetStore, clearStore will not refetch any active queries.
  const clearStore = client?.clearStore.bind(client);
  // Allows callbacks to be registered that are executed when the store is cleared. onClearStore returns an unsubscribe function that can be used to remove registered callbacks.
  const onClearStore = client?.onClearStore.bind(client);
  // Resets your entire store by clearing out your cache and then re-executing all of your active queries.
  // This makes it so that you may guarantee that there is no data left in your store from a time before you called this method.
  const resetStore = client?.resetStore.bind(client);
  // Allows callbacks to be registered that are executed when the store is reset. onResetStore returns an unsubscribe function that can be used to remove registered callbacks.
  const onResetStore = client?.onResetStore.bind(client);
  // const reFetchObservableQueries: ClientType['reFetchObservableQueries'] = clientRef.current.reFetchObservableQueries.bind(clientRef.current);

  return (
    client ?
      <ApolloProvider client={client}>
        {children({ resetStore, onResetStore, clearStore, onClearStore, wsLink: wsHasuraLink, lastUpdate })}
      </ApolloProvider>
      : null
  );
};

export default GraphqlProvider;
